import {hasKey} from 'shared/web';

import {getRowCellValue, type RowData} from 'features/eag-grid';

import {SERVICE_ITEMS_GRID_COLUMNS} from '../constants/serviceItemsGridColumns';

/**
 * Returns the ids of grid rows whose `itemType` cell matches the given service item
 * type key (LABOUR_TYPE / MATERIAL_TYPE). The itemType cell value is a LabeledKey
 * object ({key, label}); rows without the column (hidden or not loaded) never match.
 */
export const getServiceItemRowIdsByType = (rows: RowData[], itemTypeKey: string): string[] =>
  rows
    .filter((row) => {
      const itemType = getRowCellValue(row, SERVICE_ITEMS_GRID_COLUMNS.itemType);
      return hasKey(itemType, 'key') && itemType.key === itemTypeKey;
    })
    .map((row) => row.id);
